import carbonbuster from '../assets/avatars/carbonbuster.PNG';
import carboncatalyst from '../assets/avatars/carboncatalyst.PNG';
import carboncrusader from '../assets/avatars/carboncrusader.PNG';
import ecoexplorer from '../assets/avatars/ecoexplorer.PNG';
import greenhero from '../assets/avatars/greenhero.PNG';
import starter from '../assets/avatars/starter.png';

export const levelDetails = {
    100: { // for new users only
        avatar: starter,
        rank: '',
        bgColor: '#BDBDBD'
    },
    0: {
        avatar: ecoexplorer,
        rank: 'Eco Explorer',
        bgColor: '#dfc6f6'
    },
    1: {
        avatar: carboncatalyst,
        rank: 'Carbon Catalyst',
        bgColor: '#77e86b'
    },
    2: {
        avatar: carboncrusader,
        rank: 'Carbon Crusader',
        bgColor: '#fbd871'
    },
    3: {
        avatar: carbonbuster,
        rank: 'Carbon Buster',
        bgColor: '#53439b'
    },
    4: {
        avatar: greenhero,
        rank: 'Green Hero',
        bgColor: '#68dec2'
    },
}

export const getLevelFromPoints = (points) => {
    switch (true) {
        case (points < 20):
            return 0;
        case (points < 100):
            return 1;
        case (points < 250):
            return 2;
        case (points < 500):
            return 3;
        case (points >= 500):
            return 4;
        default:
            return 100;
    }
}